import './react-datepicker.scss';

import de from 'date-fns/locale/de';
import PropTypes from 'prop-types';
import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

const InputDate = ({ date, onChange, minDate, maxDate, excludedDates, excludedDays }) => {
	registerLocale('de', de);

	const isDayAvailable = currentDate => {
		const day = currentDate.getDate();
		if (excludedDays.includes(parseInt(day))) {
			return false;
		}

		return true;
	};

	return (
		<DatePicker
			dateFormat='dd.MM.yyyy'
			excludeDates={excludedDates}
			filterDate={isDayAvailable}
			locale='de'
			maxDate={maxDate}
			minDate={minDate}
			selected={date}
			showDisabledMonthNavigation
			onChange={newDate => onChange(newDate === null ? date : newDate)}
		/>
	);
};

InputDate.propTypes = {
	date: PropTypes.instanceOf(Date),
	onChange: PropTypes.func.isRequired,
	minDate: PropTypes.instanceOf(Date),
	maxDate: PropTypes.instanceOf(Date),
	excludedDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
	excludedDays: PropTypes.arrayOf(PropTypes.number)
};

InputDate.defaultProps = {
	date: new Date(),
	minDate: null,
	maxDate: null,
	excludedDates: [],
	excludedDays: []
};

export default InputDate;
